import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { Form, Tab, Tabs } from "react-bootstrap";
import AddUserInput from '../../UsersScreen/_components/AddUserInput';
import { useState } from 'react';

import trash_img from '../../../assets/images/trash.svg'
import UserReducedTable from '../../UsersScreen/_components/UserReducedTable';
import GroupReducedTable from '../../UsersScreen/_components/GroupReducedTable';
import { toast } from "react-toastify";
import AddGroupInput from '../../UsersScreen/_components/AddGroupInput';


export default function ExamPermissions (props) {

     const t = useSelector(selectTranslations)

    const handleAllowedAllChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onExamDataChange({
            ...props.examData,
            [name]: value === "true" ? true : false,
            ...(
                props?.examData?.allowed_users && props?.examData?.allowed_users?.length > 0 ?
                {
                    allowed_users: props?.examData?.allowed_users
                } :
                {
                    allowed_users: []
                }
            ),
            ...(
                props?.examData?.allowed_groups && props?.examData?.allowed_groups?.length > 0 ?
                {
                    allowed_groups: props?.examData?.allowed_groups
                } :
                {
                    allowed_groups: []
                }
            )
        })
    }

    const [usersRowSelection, setUsersRowSelection] = useState({})
    const [groupsRowSelection, setGroupsRowSelection] = useState({})

    const handleAddUser = (user) => {
        if(user && !props.examData?.allowed_users?.find(u => u.user_id === user?.user_id)){
            let currentUsers = structuredClone(props.examData?.allowed_users) || []
            currentUsers.push(user)
            props.onExamDataChange({
                ...props.examData,
                allowed_users: currentUsers,
                allowed_groups: props.examData?.allowed_groups || []
            })
        } else {
            toast.error(t.groups.error_adding_user)
        }
    }

    const handleAddGroup = (group) => {
        if(group && !props.examData?.allowed_groups?.find(u => u.group_id === group?.group_id)){
            let currentGroups = structuredClone(props.examData?.allowed_groups) || []
            currentGroups.push(group)
            props.onExamDataChange({
                ...props.examData,
                allowed_users: props.examData?.allowed_users || [],
                allowed_groups: currentGroups
            })
        } else {
            toast.error(t.groups.error_adding_group)
        }
    }

    const handleRemoveUsers = async () => {
        const users_ids = Object.keys(usersRowSelection)
        props.onExamDataChange({
            ...props.examData,
            allowed_users: props.examData?.allowed_users.filter((e) => !users_ids.includes(e.user_id))
        })
    }

    const handleRemoveGroups = () => {
        const group_ids = Object.keys(groupsRowSelection)
        
        props.onExamDataChange({
            ...props.examData,
            allowed_groups: props.examData?.allowed_groups.filter((e) => !group_ids.includes(e.group_id))
        })
    }
 
    return (
        <div className='exams-step-4'>
            <div className="info_card">
                <h2>{t.exam.recipient_type} "{props.examData.title}"</h2>
                <div className='mt-3'>
                    <Form.Check
                        inline
                        label={t.permissions.all_students}
                        name="allowed_all"
                        type={'radio'}
                        id="all"
                        value={true}
                        checked={props.examData?.allowed_all || false}
                        onChange={handleAllowedAllChange}
                    />
                    <Form.Check
                        inline
                        label={t.permissions.single_students_or_group}
                        name="allowed_all"
                        type={'radio'}
                        id="specific"
                        value={false}
                        checked={!props.examData?.allowed_all || false}
                        onChange={handleAllowedAllChange}
                    />
                </div>
            </div>
            {
                !props.examData?.allowed_all ?
                <>
                    <Tabs
                        defaultActiveKey="users"
                        id="noanim-tab-example"
                        className="mt-3 mb-4 rounded_tabs"
                    >
                        <Tab eventKey="users" title={`${t.permissions.single_students} (${props.examData?.allowed_users?.length || 0})`}>
                            <div className="d-flex justify-content-between mb-2">
                                
                                <AddUserInput onAddUser={handleAddUser} invalidUsers={props.examData?.allowed_users?.map(u => u.user_id)} label={t.groups.add_user}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(usersRowSelection).length > 0 ? handleRemoveUsers : null} disabled={Object.keys(usersRowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_user}
                                    </div>
                                </div>
                            </div>
                            <UserReducedTable data={props.examData?.allowed_users} rowSelection={usersRowSelection} setRowSelection={setUsersRowSelection} />
                        </Tab>
                        <Tab eventKey="groups" title={`${t.permissions.groups} (${props.examData?.allowed_groups?.length || 0})`}>
                            <div className="d-flex justify-content-between mb-2">
                                <AddGroupInput onAddGroup={handleAddGroup} invalidGroups={props.examData?.allowed_groups?.map(g => g.group_id)} label={t.groups.add_group}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(groupsRowSelection).length > 0 ? handleRemoveGroups : null} disabled={Object.keys(groupsRowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_group}
                                    </div>
                                </div>
                            </div>
                            <GroupReducedTable data={props.examData?.allowed_groups} rowSelection={groupsRowSelection} setRowSelection={setGroupsRowSelection} />
                        </Tab>
                    </Tabs>

                </> : null
            }
            <>
            </>
        </div>
        
    )
}